<template>
<div>
  <b-icon size="is-large" icon="emoticon-sad-outline"></b-icon>
  <h1 class="title">Page non trouvée.</h1>
</div>
</template>

<script>
export default {
name: "404"
}
</script>

<style scoped>

</style>